/* eslint-disable max-len */
/* THIS IS GENERATED BY generateBlockMaps.js - PLEASE DO NOT EDIT */
import {
    BankingAmortizationCalc,
    MortgageAffordabilityCalculator,
    MortgageDownPaymentCalculator,
    MortgageLandTransferTaxCalculator,
    MortgagePaymentCalculator,
    MortgagePenaltyCalculator,
    MortgageRefinanceCalculator,
} from '@ratehub/web-components';


const BLOCK_TO_COMPONENT_MAP = {
    [BankingAmortizationCalc.blockKey]: { render: BankingAmortizationCalc },
    [MortgageAffordabilityCalculator.blockKey]: { render: MortgageAffordabilityCalculator },
    [MortgageDownPaymentCalculator.blockKey]: { render: MortgageDownPaymentCalculator },
    [MortgageLandTransferTaxCalculator.blockKey]: { render: MortgageLandTransferTaxCalculator },
    [MortgagePaymentCalculator.blockKey]: { render: MortgagePaymentCalculator },
    [MortgagePenaltyCalculator.blockKey]: { render: MortgagePenaltyCalculator },
    [MortgageRefinanceCalculator.blockKey]: { render: MortgageRefinanceCalculator },
};

export default BLOCK_TO_COMPONENT_MAP;
